module.exports = __webpack_public_path__ + "static/img/contentRightImg5.490bd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg5.png
// module id = Fqyj
// module chunks = 2